<template>
    <div id="Index">
        <div class="animate">
            <div class="mask" v-show="maskShow">
                <img src="../assets/img/op-title.png" alt="">
                <img v-show="step === 0" src="../assets/img/send-button.png" alt="" @click="toAnimate">
                <img v-for="(img, index) of indexBG"
                     :src="img"
                     :key="index"
                     :class="`background ${index === bgIndex && 'active-bg'}`"
                     alt="">
                <video ref="video" src="../assets/open.mp4" class="video-tag" style="display: none" x5-playsinline="" playsinline="" webkit-playsinline="" poster="" preload="auto"></video>
<!--                <video ref="video" :class="`${step === 1 && 'active-bg'}`" src="../assets/open.mp4" x5-playsinline="" playsinline="" webkit-playsinline="" poster="" preload="auto"></video>-->
                <canvas id="canvas" :class="`${step === 1 && 'active-bg'}`"></canvas>
                <img v-show="step === 1" @click="jump" class="jump" src="../assets/img/jump.png" alt="">
            </div>
        </div>
        <div class="area-change" v-show="!maskShow">
            <img src="../assets/img/map.png" alt="">
            <div class="input-box">
                <div>选择要点亮的城市</div>
                <div @click="actionSheet = true">
                    <!--{{area}}-->
                    <input type="text" placeholder="请选择" v-model="area" readonly>
                </div>
                <div class="red-btn" @click="submit">确定</div>
            </div>
        </div>
        <ActionSheet v-model="actionSheet" :actions="actions" @select="onSelect" ></ActionSheet>
    </div>
</template>

<script>
    import {ActionSheet, Toast} from 'vant'
    import axios from 'axios'
    export default {
        name: "Index",
        components: {
            ActionSheet
        },
        data() {
            return {
                step: 0,
                // backgroundActive: require('../assets/img/bg.jpg'),
                bgIndex: 0,
                indexBG: [
                    require('../assets/img/jinan-index.jpg'),
                    require('../assets/img/qingdao-index.jpg'),
                    require('../assets/img/zibo-index.jpg'),
                    require('../assets/img/zaozhuang-index.jpg'),
                    require('../assets/img/dongying-index.jpg'),
                    require('../assets/img/yantai-index.jpg'),
                    require('../assets/img/weifang-index.jpg'),
                    require('../assets/img/jining-index.jpg'),
                    require('../assets/img/taian-index.jpg'),
                    require('../assets/img/weihai-index.jpg'),
                    require('../assets/img/rizhao-index.jpg'),
                    require('../assets/img/linyi-index.jpg'),
                    require('../assets/img/dezhou-index.jpg'),
                    require('../assets/img/liaocheng-index.jpg'),
                    require('../assets/img/binzhou-index.jpg'),
                    require('../assets/img/heze-index.jpg')
                ],
                timer: '',
                maskShow: true,
                area: '',
                actionSheet: false,
                actions: [
                    { name: '济南' },
                    { name: '青岛' },
                    { name: '淄博' },
                    { name: '枣庄' },
                    { name: '东营' },
                    { name: '烟台' },
                    { name: '潍坊' },
                    { name: '济宁' },
                    { name: '泰安' },
                    { name: '威海' },
                    { name: '日照' },
                    { name: '临沂' },
                    { name: '德州' },
                    { name: '聊城' },
                    { name: '滨州' },
                    { name: '菏泽' }
                ],
                openid: ''
            }
        },
        methods: {
            onSelect(item) {
                // 默认情况下点击选项时不会自动收起
                // 可以通过 close-on-click-action 属性开启自动收起
                this.actionSheet = false;
                this.area = item.name
                // Toast(item.name);
            },
            toAnimate() {
                this.step++
                // if (this.step === 1) {
                //     clearTimeout(this.timer)
                //     this.$refs.video.play()
                //     this.$refs.video.addEventListener('ended', () => {
                //         this.maskShow = false
                //     })
                // }


                if (this.step === 1) {
                    clearTimeout(this.timer)
                    var canvas = document.getElementById('canvas');
                    var cobj = canvas.getContext('2d'); //获取绘图环境
                    var body = document.getElementsByTagName('body')[0];
                    canvas.width = screen.availWidth;
                    canvas.height = screen.availHeight;
                    //                 var img = document.getElementsByTagName('img')[0];
                    var video = this.$refs.video;
                    //                 cobj.drawImage(img, 200, 200, 200, 200);//把图片画在画布上
                    // body.onclick = function() {}
                    video.play();
                    video.addEventListener('play', function() {
                        //画布上画视频，需要动态地获取它，一帧一帧地画出来
                        setInterval(function() {
                            cobj.drawImage(video, 0, 0, screen.availWidth, screen.availHeight);
                        }, 20);
                    })
                    // this.$refs.video.play()
                    video.addEventListener('ended', () => {
                        this.maskShow = false
                    })
                }

                // video.addEventListener("timeupdate",function(){
                //     var timeDisplay;
                //     //用秒数来显示当前播放进度
                //     timeDisplay = Math.floor(video.currentTime);
                //     if(timeDisplay == 37){
                //         video.currentTime = 2
                //     }
                // },false);
            },
            jump() {
                this.$refs.video.pause()
                this.maskShow = false
            },
            initBGChange() {
                this.timer = setInterval(() => {
                    if (this.bgIndex + 1 < this.indexBG.length) {
                        this.bgIndex++
                    } else {
                        this.bgIndex = 0
                    }
                }, 3000)
            },
            submit() {
                if(this.area) {
                    this.$router.push({
                        path: '/Mars',
                        query: {
                            area: this.area,
                            openid: this.openid
                        }
                    })
                }else {
                    Toast('选择地区点亮')
                }
            },
            getCode () { // 非静默授权，第一次有弹框
                this.code = ''
                let local = window.location.href // 获取页面url
                // let local = 'http://zhuanti.e23.cn'
                console.log(local)
                // 舜网appid
                let appid = 'wxac55a9cd0f1cd9df'
                // let appid = 'wx3260067c2f753c59'
                this.code = this.getUrlCode().code // 截取code
                if (this.code == null || this.code === '') { // 如果没有code，则去请求
                    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
                } else {
                    // console.log(this.code)
                    // let data = new FormData()
                    // data.append('code', this.code)
                    axios.get('http://zhuanti.e23.cn/index.php?m=content&c=huoju&a=getOpenid', {
                        params: {
                            code: this.code
                        }
                    }).then(res => {
                        if(res.data.code === 200) {
                            this.openid = res.data.openid
                        }else {
                            let loc = 'http://zhuanti.e23.cn/html/torch/index.html'
                            // let loc = `http://zqyey.jnzqhg.cn`
                            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(loc)}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
                        }
                        console.log(res)
                    })
                    // 你自己的业务逻辑
                }
            },
            getUrlCode() { // 截取url中的code方法
                var url = location.search
                this.winUrl = url
                var theRequest = new Object()
                if (url.indexOf("?") != -1) {
                    var str = url.substr(1)
                    var strs = str.split("&")
                    for(var i = 0; i < strs.length; i ++) {
                        theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
                    }
                }
                return theRequest
            },
            test() {
                console.log(1)
                this.actionSheet = true
            }
        },
        created() {
            this.getCode()
            this.initBGChange()
        }
    }
</script>

<style scoped lang="less">
    #Index {
        width: 100vw;
        height: 100vh;

        .animate {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            /*background: url("../assets/img/bg.jpg");*/
            background-size: 100% 100%;

            .mask {
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, .7);
                display: flex;
                flex-direction: column;
                align-items: center;

                > img:nth-of-type(1) {
                    /*width: 50vw;*/
                    height: 68vh;
                }

                > img:nth-of-type(2) {
                    margin-top: 5vh;
                    width: 45vw;
                }

                .background {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100vw;
                    height: 100vh;
                    z-index: -1;
                    opacity: 0;
                    transition: all 1s;
                }

                .active-bg {
                    opacity: 1;
                    transition: all 1.5s;
                }

                video {
                    position: absolute;
                    left: 0;
                    right: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    z-index: -1;
                    opacity: 0;
                }

                #canvas {
                    position: absolute;
                    left: 0;
                    right: 0;
                    width: 100%;
                    height: 100%;
                    z-index: -1;
                    opacity: 1;
                }

                .jump {
                    position: absolute;
                    right: 2vw;
                    top: 20vw;
                    width: 20vw;
                }

                .video-tag {
                    opacity: 0;
                }
            }
        }

        .area-change {
            position: absolute;
            width: 100%;
            height: 100%;
            background: url("../assets/img/map-bg.jpg");
            background-size: 100% 100%;
            z-index: 1;

            > img {
                margin-top: 15vh;
                display: block;
                width: 100%;
            }

            .input-box {
                margin-top: 10vh;

                > div {
                    margin: 0 auto;

                    &:nth-of-type(1) {
                        text-align: center;
                        font-size: 5vw;
                        /*font-weight: 600;*/
                        color: black;
                    }

                    &:nth-of-type(2) {
                        border: 1px solid rgb(6, 6, 6);
                        width: 60vw;
                        height: 8vw;
                        border-radius: 2vw;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-top: 4vw;

                        > input {
                            width: 90%;
                            height: 90%;
                            border: none;
                            background: rgba(0, 0, 0, 0);
                        }
                    }
                }

                .red-btn {
                    margin-top: 6vh;
                    width: 20vw;
                    height: 8vw;
                    color: white;
                    background: red;
                    text-align: center;
                    line-height: 8vw;
                    border-radius: 2vw;
                    font-size: 5vw;
                }
            }
        }
    }
</style>
